/* eslint-disable react/no-danger */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-to-interactive-role */
/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable import/prefer-default-export */
import { Box, CircularProgress } from '@mui/material'
import React from 'react'
import ImageIcon from '@mui/icons-material/Photo'
import CloudUploadIcon from '@mui/icons-material/CloudUpload'
import excelIcon from './fileIcons/excel.svg'
import csvIcon from './fileIcons/csv.svg'
import genericIcon from './fileIcons/generic.svg'

function extractFileType(fileName = '') {
  return fileName.split('.').pop().split('?')[0].toLowerCase()
}

function isImageFile(fileName = '') {
  if (typeof fileName !== 'string') {
    return false
  }
  const fileType = extractFileType(fileName)
  return ['jpeg', 'jpg', 'png', 'gif'].includes(fileType)
}

function getFileTypeIcon(fileName = '') {
  switch (extractFileType(fileName)) {
    case 'csv':
      return (
        <div style={{ width: '40px' }} dangerouslySetInnerHTML={{ __html: csvIcon }} />
      )
    case 'xls':
    case 'xlsx':
      return (
        <div style={{ width: '40px' }} dangerouslySetInnerHTML={{ __html: excelIcon }} />
      )
    case 'jpeg':
    case 'jpg':
    case 'png':
    case 'gif':
      return <ImageIcon sx={{ fontSize: 40 }} />
    default:
      return (
        <div style={{ width: '40px' }} dangerouslySetInnerHTML={{ __html: genericIcon }} />
      )
  }
}

function MUIControlledFileInputV2({
  innerRef,
  name,
  value,
  fileTypes = '*',
  onChange,
  processing = false,
  gxid = '',
  showRemoveOption = true,
  showDescription = true,
  descriptionItems = ['Supports JPG, JPEG, PNG', 'Max file size 2MB'],
}) {
  function handleChange(event) {
    event.preventDefault()
    onChange(event.target.files[0])
  }

  function clearInput() {
    const input = document.getElementById(`fileInput_${name}`)
    if (input) {
      input.value = ''
    }
    onChange(null)
  }

  const isImage = value && (isImageFile(value?.name) || isImageFile(value))

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        fontSize: '0.875rem',
        lineHeight: '1.5rem',
        color: '#000',
        gap: 4,
        position: 'relative',
      }}
    >
      {showDescription && descriptionItems.length > 0 && (
        <Box>
          <ul
            style={{
              marginRight: '60px',
              paddingLeft: '1.25rem',
              color: '#4f4f4f',
              fontSize: '0.875rem',
            }}
          >
            {descriptionItems.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </Box>
      )}

      <Box sx={{ position: 'relative' }}>
        <input
          name={name}
          ref={innerRef}
          type="file"
          hidden
          onChange={handleChange}
          id={`fileInput_${name}`}
          accept={fileTypes}
        />

        {!value && (
          <label
            htmlFor={`fileInput_${name}`}
            data-gxid={gxid}
            style={{ cursor: 'pointer' }}
          >
            <Box
              sx={{
                width: 150,
                height: 150,
                bgcolor: '#f5f5f5',
                borderRadius: 1,
                border: '1px solid #eeeeee',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                overflow: 'hidden',
              }}
            >
              <CloudUploadIcon sx={{ fontSize: 48, color: '#bdbdbd' }} />
            </Box>
          </label>
        )}

        {value && (
          <Box>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1,
              }}
            >
              {isImage ? (
                <img
                  src={typeof value === 'string' ? value : URL.createObjectURL(value)}
                  alt=""
                  style={{
                    width: '40px',
                    height: '40px',
                    objectFit: 'cover',
                    backgroundColor: '#d9d9d9',
                  }}
                />
              ) : (
                getFileTypeIcon(value.name)
              )}
              <Box sx={{ fontSize: '0.875rem' }}>
                {value?.name ?? value}
              </Box>
            </Box>
            <Box
              sx={{
                display: 'flex',
                mt: 1,
                gap: 2,
                fontSize: '0.875rem',
              }}
            >
              <label
                role="button"
                tabIndex={0}
                htmlFor={`fileInput_${name}`}
                style={{
                  cursor: 'pointer',
                  color: '#0e5777',
                  fontWeight: 400,
                }}
              >
                Edit
              </label>
              {showRemoveOption && (
                <button
                  type="button"
                  onClick={clearInput}
                  style={{
                    background: 'transparent',
                    border: 'none',
                    color: '#0e5777',
                    cursor: 'pointer',
                    fontWeight: 400,
                    fontSize: '0.875rem',
                    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                    padding: 0,
                  }}
                >
                  Delete
                </button>
              )}
            </Box>
          </Box>
        )}
        {processing && (
          <Box
            sx={{
              background: 'rgba(255,255,255,.75)',
              position: 'absolute',
              zIndex: 100,
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <CircularProgress />
          </Box>
        )}
      </Box>
    </Box>
  )
}

export { MUIControlledFileInputV2 }
